import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const HomeWeightIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.container, classObject), src: "/assets/images/icons/home_weight.svg" });
};
const styles = StyleSheet.create({
    container: {
        width: 22,
        height: 22,
    },
});
